<template>
  <!--角色管理 -->
  <div class="newsPage">
    <div>
      <el-card style="margin: 30px">
        <div style="display: flex;align-items: center">
          <div>审核状态：</div>
          <el-select v-model="examineStatus" size="small" style="width: 180px;margin-right: 10px" clearable placeholder="请选择审核状态">
            <el-option
                v-for="item in [{'key':3,'value':'待审核'},{'key':1,'value':'审核通过'},{'key':4,'value':'审核未通过'}]"
                :key="item.key"
                :label="item.value"
                :value="item.key">
            </el-option>
          </el-select>
          <div>资讯标题：</div>
          <el-input clearable placeholder="请输入搜索内容" size="small" style="width: 180px;margin-right: 10px" v-model="newsTitle"></el-input>
          <div>创建时间：</div>
          <el-date-picker
              v-model="dateValue"
              :clearable="false"
              @change="dateChange"
              type="daterange"
              size="small"
              style="margin-right: 10px"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
          </el-date-picker>
        </div>

        <div style="display: flex;align-items: center;margin-top: 20px">
          <div>排序方式：</div>
          <el-select v-model="sortType" size="small" style="width: 180px;margin-right: 10px" clearable placeholder="请选择排序方式">
            <el-option
                v-for="item in [{'key':1,'value':'创建时间'},{'key':2,'value':'权重时间'}]"
                :key="item.key"
                :label="item.value"
                :value="item.key">
            </el-option>
          </el-select>
          <div>是否置顶：</div>
          <el-select v-model="isHot" size="small" style="width: 180px;margin-right: 10px" clearable placeholder="请选择">
            <el-option
                v-for="item in [{'key':1,'value':'是'},{'key':0,'value':'否'}]"
                :key="item.key"
                :label="item.value"
                :value="item.key">
            </el-option>
          </el-select>
          <div>是否热点：</div>
          <el-select v-model="isHotspot" size="small" style="width: 180px;margin-right: 10px" clearable placeholder="请选择">
            <el-option
                v-for="item in [{'key':1,'value':'是'},{'key':0,'value':'否'}]"
                :key="item.key"
                :label="item.value"
                :value="item.key">
            </el-option>
          </el-select>
          <el-button @click="searchBtn" type="primary" size="small">查询</el-button>
          <el-button size="small" type="danger" @click="resetBtn">重置</el-button>
          <el-button v-if="auditBatchList&&auditBatchList.length" @click="auditBatchBtn" size="small" type="danger">批量审核</el-button>
          <el-button v-if="multipleSelection&&multipleSelection.length" @click="batchDeleteBtn" size="small" type="danger">批量删除</el-button>
        </div>

        <el-table
            size="small"
            ref="multipleTable"
            tooltip-effect="dark"
            :data="tableData"
            @selection-change="handleSelectionChange"
            border
            style="width: 100%;margin-top: 30px"
        >
          <el-table-column
              type="selection"
              align="center"
              width="55">
          </el-table-column>

          <el-table-column label="资讯标题" width="500" align="center" prop="news_title" show-overflow-tooltip>
            <!-- <template slot-scope="scope">
              <a-tooltip placement="right" trigger="click">
                <template slot="title">
                  {{scope.row.news_title}}
                </template>
                <span style="width:570px;height:40px;display: -webkit-box;-webkit-box-orient: vertical;text-overflow: ellipsis;-webkit-line-clamp: 2;overflow : hidden;">{{ scope.row.news_title }}</span>
              </a-tooltip>
            </template> -->
          </el-table-column>
          <el-table-column label="发布者" prop="nickname" align="center"></el-table-column>
          <el-table-column label="点赞数" prop="favor_count" align="center"></el-table-column>
          <el-table-column label="播放数" prop="watch_count" align="center"></el-table-column>
          <el-table-column label="是否热点" width="80" align="center">
            <template slot-scope="scope">
              <div>{{ scope.row.is_hotspot ? scope.row.is_hotspot === '0'?'否':'是' : '' }}</div>
            </template>
          </el-table-column>
          <el-table-column label="是否置顶" width="80" align="center">
            <template slot-scope="scope">
              <div>{{ scope.row.is_hot ? scope.row.is_hot === '0'?'否':'是' : '' }}</div>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" width="120" align="center">
            <template slot-scope="scope">
              <a-tooltip placement="right" trigger="click">
                <template slot="title">
                  {{scope.row.create_date}}
                </template>
                {{ scope.row.create_date_list[0] }}
              </a-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="权重时间" width="120" align="center">
            <template slot-scope="scope">
              <a-tooltip placement="right" trigger="click">
                <template slot="title">
                  {{scope.row.sortTime}}
                </template>
                {{ scope.row.sortTimeList[0] }}
              </a-tooltip>
            </template>
          </el-table-column>
          <el-table-column header-align="center" width="120" label="审核状态">
            <template slot-scope="scope">
              <div style="display: flex;align-items: center;justify-content: center">
                <el-tag type="warning" size="small" effect="dark" v-if="scope.row.examine_status === '2' || scope.row.examine_status === '3'">待审核</el-tag>
                <el-tag type="success" size="small" effect="dark" v-else-if="scope.row.examine_status === '1'">审核通过</el-tag>
                <el-tag type="danger" size="small" effect="dark" v-else-if="scope.row.examine_status === '4'">审核未通过</el-tag>
                <el-tag type="info" size="small" effect="dark" v-else-if="scope.row.examine_status === '5'">下架</el-tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column
              width="500px"
              align="center"
              label="操作"

          >
            <template slot-scope="scope">
              <el-button
                @click="copy"
                type="primary"
                size="mini"
                class="btns"
                :data-clipboard-text="'https://www.weiguanzixun.com/sharePage?id=' + scope.row.id"
            >复制链接</el-button>
              <el-button @click="viewBtn(scope.row)" size="small" type="success">预览</el-button>
              <el-button @click="auditBtn(scope.row)" v-if="scope.row.examine_status === '2' || scope.row.examine_status === '3'" size="small" type="success">审核</el-button>
              <el-button @click="editBtn(scope.row)" size="small" type="success">修改</el-button>
              <el-button @click="deleteBtn(scope.row)" size="small" type="danger">删除</el-button>
              <el-button
                  @click="poster(scope.row.id)"
                  size="mini"
                  type="primary"
              >生成海报</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            style="display: flex;justify-content: center;margin-top: 20px"
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[20, 30, 40, 50]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalElements">
        </el-pagination>
      </el-card>
    </div>
    <!--    删除的弹窗-->
    <a-modal
        title="提示"
        :visible="deleteDialogState"
        cancel-text="取消"
        ok-text="确认"
        width="400px"
        @cancel="deleteCancel"
        @ok="deleteSubmit"
    >
      <div>{{simpleDelete?'是否删除该条记录？':'是否删除当前所选中的记录？'}}</div>
    </a-modal>

    <a-modal
        :visible="editDialogState"
        cancel-text="取消"
        ok-text="确认"
        title="修改"
        width="400px"
        @cancel="editCancel"
        @ok="editSubmit('editRuleForm')"
    >
      <el-form
          ref="editRuleForm"
          :model="editRuleForm"
          class="small-space"
          label-position="right"
          label-width="100px"
      >

        <el-form-item label="权重">
          <el-date-picker
              v-model="editRuleForm.sort"
              type="datetime"
              value-format="timestamp"
              placeholder="选择日期时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker
              v-model="editRuleForm.createDate"
              type="datetime"
              placeholder="选择日期时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="播放量">
          <el-input-number :min="0" v-model="editRuleForm.watchCount"></el-input-number>
        </el-form-item>
        <el-form-item label="点赞量">
          <el-input-number :min="0" v-model="editRuleForm.favorCount" :max="editRuleForm.watchCount"></el-input-number>
        </el-form-item>
        <el-form-item label="是否热点">
          <el-select style="width: 180px" v-model="editRuleForm.isHotspot" placeholder="请选择">
            <el-option
                v-for="item in [{key:'0',value:'否'},{key:'1',value: '是'}]"
                :key="item.key"
                :label="item.value"
                :value="item.key">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否置顶">
          <el-select style="width: 180px" v-model="editRuleForm.isHot" placeholder="请选择">
            <el-option
                v-for="item in [{key:'0',value:'否'},{key:'1',value: '是'}]"
                :key="item.key"
                :label="item.value"
                :value="item.key">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </a-modal>

    <!--    审核的弹窗-->
    <a-modal
        :visible="auditDialogState"
        cancel-text="取消"
        ok-text="确认"
        title="审核"
        width="400px"
        @cancel="auditCancel"
        @ok="auditSubmit('auditRuleForm')"
    >
      <el-form
          ref="auditRuleForm"
          :model="auditRuleForm"
          :rules="auditRules"
          class="small-space"
          label-position="right"
          label-width="100px"
      >
        <el-form-item label="审核状态" prop="examineStatus">
          <el-select v-model="auditRuleForm.examineStatus" size="small" style="width: 180px;margin-right: 10px" clearable placeholder="请选择审核状态">
            <el-option
                v-for="item in [{'key':1,'value':'审核通过'},{'key':4,'value':'审核未通过'}]"
                :key="item.key"
                :label="item.value"
                :value="item.key">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </a-modal>
  </div>
</template>
<script>
import moment from "moment";
import Clipboard from "clipboard";
export default {
  data() {
    return {
      pageNum: 1,
      pageSize: 20,
      examineStatus:null,
      newsTitle:'',
      sortType:null,
      isHotspot:null,
      isHot: null,
      dateValue:'',
      createStartDate:'',
      createEndDate:'',
      tableData:[],
      totalElements: 0,//数据总数
      multipleSelection:[],
      auditBatchList:[],
      deleteDialogState:false,
      deleteId:'',
      simpleDelete:false,//是单个删除还是多个删除
      auditDialogState:false,
      auditRuleForm:{
        examineStatus:null
      },
      auditRules:{
        examineStatus: [{required: true, message: "请选择审核状态", trigger: "blur"}],
      },
      simpleAudit:false,
      auditId:'',
      editDialogState:false,
      editRuleForm:{
        id:'',
        sort:0,
        createDate: null,
        favorCount:0,
        watchCount:0,
        isHotspot:null,
        isHot:null
      }
    };
  },
  methods: {
    copy() {
      var that = this;
      var clipboard = new Clipboard(".btns"); //单页面引用
      clipboard.on("success", (e) => {
        this.$message.success("复制成功");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        this.$message.error("该浏览器不支持自动复制");
        // 释放内存
        clipboard.destroy();
      });
    },
    createDateChange(row){
      this.$set(row,'create_date_show',row.create_date_show = !row.create_date_show)
      console.log(row.create_date_show,9999)
    },
    searchBtn() {
      this.pageNum = 1
      this.pageSize = 20
      this.getNewsList()
    },
    resetBtn() {
      this.pageNum = 1
      this.pageSize = 20
      this.examineStatus = null
      this.sortType = null
      this.isHotspot = null
      this.isHot = null
      this.newsTitle = ''
      this.createStartDate = ''
      this.createEndDate = ''
      this.dateValue = ''
      this.getNewsList()
    },
    dateChange(e){
      this.dateValue = e
      this.createStartDate = moment(this.dateValue[0]).format('YYYY-MM-DD')
      this.createEndDate = moment(this.dateValue[1]).format('YYYY-MM-DD')
    },
    editBtn(row){
      this.editRuleForm.id = row.id
      this.editRuleForm.favorCount = row.favor_count
      this.editRuleForm.watchCount = row.watch_count
      this.editRuleForm.isHot = row.is_hot?row.is_hot:null
      this.editRuleForm.isHotspot = row.is_hotspot?row.is_hotspot:null
      this.editRuleForm.sort = Number(row.sort)*1000
      this.editRuleForm.createDate = row.create_date
      this.editDialogState = true
    },
    deleteBtn(row){
      this.simpleDelete = true
      this.deleteId = row.id
      this.deleteDialogState = true
    },
    // 生成海报
    poster(id) {
      this.getAxios("/news/generate/poster", {
        newsInfoId: id,
      }).then((res) => {
        if (res.success == true) {
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    auditBtn(row){
      this.simpleAudit = true
      this.auditId = row.id
      this.auditRuleForm.examineStatus = 1
      this.auditDialogState = true
    },
    viewBtn(row){
      this.$router.push({ path: "/previewPage",query:{
                  id:row.id
                }});
    },
    batchDeleteBtn(){
      this.simpleDelete = false
      this.auditRuleForm.examineStatus = 1
      this.deleteDialogState = true
    },
    auditBatchBtn(){
      this.simpleAudit = false
      this.auditDialogState = true
    },
    deleteCancel(){
      this.deleteDialogState = false
    },
    auditCancel(){
      this.auditDialogState = false
    },
    editCancel() {
      this.editDialogState = false
    },
    editSubmit(formName){
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.editRuleForm.sort.toString().length === 13){
            this.editRuleForm.sort = Number(this.editRuleForm.sort)/1000
          }
          if(this.editRuleForm.createDate){
            this.editRuleForm.createDate = moment(this.editRuleForm.createDate).format('YYYY-MM-DD HH:mm:ss')
          }
          this.postAxios("/newNews/updNewsById", this.editRuleForm).then(res=>{
            if (res.success){
              this.$message.success(res.message)
              this.editDialogState = false
              this.getNewsList()
            }
          })
        }
      });
    },
    auditSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.simpleAudit){
            this.postAxios("/newNews/examineNewsByIds", {
              examineStatus:this.auditRuleForm.examineStatus,
              idList:[this.auditId]
            }).then(res=>{
              if (res.success){
                this.$message.success(res.message)
                this.auditId = ''
                this.auditDialogState = false
                this.getNewsList()
              }
            })
          }else{
            this.postAxios("/newNews/examineNewsByIds", {
              examineStatus:this.auditRuleForm.examineStatus,
              idList:this.auditBatchList
            }).then(res=>{
              if (res.success){
                this.$message.success(res.message)
                this.auditBatchList = []
                this.multipleSelection = []
                this.auditDialogState = false
                this.getNewsList()
              }
            })
          }
        }
      });
    },
    deleteSubmit(){
      if (this.simpleDelete){
        //单个删除
        this.postAxios("/newNews/delNewsByIds", [
          this.deleteId
        ]).then(res=>{
          if (res.success){
            this.$message.success(res.message)
            this.deleteId = ''
            this.deleteDialogState = false
            this.getNewsList()
          }
        })
      }else{
        //多个删除
        let ids = []
        this.multipleSelection.forEach((item)=>{
          ids.push(item.id)
        })
        this.postAxios("/newNews/delNewsByIds", ids).then(res=>{
          if (res.success){
            this.$message.success(res.message)
            this.deleteId = ''
            this.deleteDialogState = false
            this.getNewsList()
          }
        })
      }
    },
    //用户列表
    getNewsList() {
      this.postAxios("/newNews/getAllNews", {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        parameterMap: {
          examineStatus: this.examineStatus?this.examineStatus:null,
          newsTitle: this.newsTitle,
          createStartDate: this.createStartDate,
          createEndDate: this.createEndDate,
          sortType:this.sortType?this.sortType:null,
          isHotspot:this.isHotspot ? this.isHotspot : this.isHotspot === 0 ? this.isHotspot : null,
          isHot:this.isHot ? this.isHot : this.isHot === 0 ? this.isHot : null,
        }
      }).then(res => {
        if (res.success) {
          this.tableData = []
          this.tableData = res.content;
          this.tableData.forEach((item)=>{
            if (item.sort || item.sort === 0){
              item.sortTime = moment(Number(item.sort)*1000).format('YYYY-MM-DD HH:mm:ss')
              item.sortTimeList = item.sortTime.split(' ')
            }
            item.create_date_list = item.create_date.split(' ')
            item.create_date_show = false
          })
          this.totalElements = res.totalCount
        } else {
          this.tableData = []
        }
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.auditBatchList = []
      if (this.multipleSelection&&this.multipleSelection.length){
        this.multipleSelection.forEach((item)=>{
          if (item.examine_status === '2' || item.examine_status === '3'){
            this.auditBatchList.push(item.id)
          }
        })
      }
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getNewsList()
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.getNewsList()
    }
  },
  created() {
    this.getNewsList(); //用户的列表
  }
};
</script>
<style lang="less" scoped>

</style>
